const styles = {
  content: {
    px: 3,
    py: 1,
  },
  actions: {
    px: 3,
    pb: 3,
    pt: 2,
  },
};

export default styles;
